<template>
  <div ref="specilWrap" class="specil-wrap" @touchmove.prevent>
    <Loadding ref="load" class="load-wrap" :submitInfo="`提交数据中...`" />
    <FillStep class="top-wrap" />
    <div class="fill-warp" style="background:#fff;">
      <div class="sign-words">
        本人承诺以上信息的真实、完整，同时接受背景调查，一旦发现信息出现作假、不实或其他违反本人承诺的情况，所有后果本人自行承担，公司有权不予录取，或公司可单方面解除劳动合同，且本人愿退回因此所获利益。
        <h3 class="tishi">请手写签名:</h3>
      </div>
      <canvas id="signPad" ref="signPad"></canvas>
      <h6 class="words sign-time">时间：{{ nowTime }}</h6>
      <div class="bottom-btn">
        <van-button
          class="default-btn"
          block
          type="info"
          color="#E39E54"
          @click="clearPad"
          >重写</van-button
        >
        <van-button
          class="default-btn"
          block
          type="info"
          color="#E39E54"
          @click="defaultClick"
          >确认</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "../../utils/request";
import API from "../../utils/API";
import FillStep from "../userRegistration/comp/fillStep";
import SignaturePad from "signature_pad";
import { mapState } from "vuex";
import moment from "moment";
import Loadding from "../other/comp/load";
import {handleTestUrlData} from './utils/common';
import { getQueryFromUrl } from '@/utils/tool';
export default {
  name: "signature",
  data() {
    return {
      nowTime: moment().format("YYYY-MM-DD"),
      canvasHeight: "",
      canvasWidth: "",
      config: {
        penColor: "rgb(0, 0, 0)", //笔刷颜色
        minWidth: 1, //最小宽度
        maxWidth: 2,
      },
      signaturePad: null,
    };
  },
  components: {
    FillStep,
    Loadding,
  },
  computed: {
    ...mapState(["baseinfo", "education", "workExp", "inviteCode"]),
  },
  mounted() {
    window.scrollTo(0, 0);
    let canvas = document.querySelector(`#signPad`);
    this.resizeCanvas(canvas);
  },
  methods: {
    defaultClick() {
      let signIsEmpty = this.signaturePad.isEmpty();
      if (signIsEmpty) {
        this.$toast({
          message: "请签名后提交！",
          duration: 2500,
        });
        return;
      }
      const isOnline = getQueryFromUrl('type') === 'online';
      let signDataImg = this.signaturePad.toDataURL();
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      let baseinfo = JSON.parse(localStorage.getItem("baseinfo"));
      let work = JSON.parse(localStorage.getItem("work"));
      let education = JSON.parse(localStorage.getItem("education"));
      let defaultQuery = Object.assign({}, baseinfo, work.otherInfo, {
        interview_id: loginInfo.code, // 面试邀请码，
        talent_id: loginInfo.talent_id, // 人才id
        ability_id: loginInfo.ability_id, // 岗位
        signUrl: signDataImg, //base64图片
        studyExp: JSON.stringify(education.studyExp), // 学习经历
        train: JSON.stringify(education.train), // 培训经历
        tags: JSON.stringify(work.tags), // 标签
        workInfo: JSON.stringify(work.workInfo), // 工作经历
        adjust_process: isOnline ? 0 : 1, // 应聘表确认后调整面试流程 => 如果是线上填写，不需要调整；否则调整为：1面试中
      });
      this.$refs.load.openLoad();
      request({
        method: "post",
        url: API.POST_APPLY_INFO,
        data: defaultQuery,
      })
        .then((res) => {
          this.$refs.load.closeLoad();
          if (res.data.msg == "success") {
            this.$toast({
              message: "保存成功",
              duration: 2500,
            });
            localStorage.removeItem("baseinfo");
            localStorage.removeItem("work");
            localStorage.removeItem("education");
            let testUrlData = handleTestUrlData(defaultQuery);
            localStorage.setItem("testUrlData", JSON.stringify(testUrlData));
            this.$router.replace("/fillOver");
          }
        })
        .catch((err) => {
          this.$refs.load.closeLoad();
        });
    },
    resizeCanvas(canvas) {
      let ratio = Math.max(window.devicePixelRatio || 1, 2);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "rgba(255, 255, 255, 0)";
      ctx.scale(ratio, ratio);
      // console.log(canvas.width, canvas.height)
      this.signaturePad = new SignaturePad(canvas, this.config);
      // console.log(this.signaturePad)
      this.clearPad();
    },
    clearPad() {
      this.signaturePad.clear();
    },
    resizeScreen() {
      const _this = this;
      // 利用 CSS3 旋转 对根容器逆时针旋转 90 度
      const detectOrient = () => {
        let width = document.documentElement.clientWidth,
          height = document.documentElement.clientHeight,
          wrapper = _this.$refs["specilWrap"], // 这里是页面最外层元素
          style = "";
        if (width >= height) {
          // 横屏
          style += "width:" + width + "px;"; // 注意旋转后的宽高切换
          style += "height:" + height + "px;";
          style += "-webkit-transform: rotate(0); transform: rotate(0);";
          style += "-webkit-transform-origin: 0 0;";
          style += "transform-origin: 0 0;";
        } else {
          // 竖屏
          style += "width:" + height + "px;";
          style += "height:" + width + "px;";
          style +=
            "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
          // 注意旋转中点的处理
          style +=
            "-webkit-transform-origin: " +
            width / 2 +
            "px " +
            width / 2 +
            "px;";
          style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
        }
        wrapper.style.cssText = style;
      };
      window.onresize = detectOrient;
      detectOrient();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/page.css";
.specil-wrap {
  // min-height: 120vh;
  // overflow-y: scroll;
  .top-wrap {
    overflow-x: hidden;
    .item-content {
      margin-top: 0;
    }
  }
  .sign-words {
    font-weight: bold;
    color: #323232;
    line-height: 21px;
    font-size: 15px;
    margin: 15px 15px 5px 15px;
    text-indent: 2em;
  }
  .tishi {
    font-weight: 400;
    color: #323232;
    line-height: 21px;
    font-size: 15px;
    margin-top: 10px;
  }
  .words {
    font-weight: normal;
    font-size: 14px;
  }

  #signPad {
    width: calc(100% - 32px);
    height: calc(100vh - 330px);
    max-height: 200px;
    margin-left: 16px;
    text-align: center;
    background: #f5f5f5;
  }
  .sign-time {
    display: flex;
    justify-content: flex-end;
    margin: 0px 32px 10px 0;
  }
  .bottom-btn {
    position: fixed;
    z-index: 999;
    display: flex;
    bottom: 2px;
    justify-content: space-around;
    width: 100%;
    .default-btn {
      height: 50px;
      width: 40%;
      border-radius: 5px;
      font-size: 16px;
    }
  }
}
.load-wrap {
  position: absolute;
  z-index: 9999;
}
</style>
